<template>
  <div>
    <h1 class="mb-4">Error Report</h1>

    <b-row>
      <b-col cols="4">
        <BaseDateOfBirthInput v-model="startDate"
                       :v="$v.startDate"
                       slug="startDate"
                       label="Start Date"
                       setId="startDate"
                       tip="Format: MM/DD/YYYY"
        />
      </b-col>
      <b-col cols="4">
        <BaseDateOfBirthInput v-model="endDate"
                       :v="$v.endDate"
                       slug="endDate"
                       label="End Date"
                       setId="endDate"
                       tip="Format: MM/DD/YYYY"
        />
      </b-col>
      <b-col cols="4">
        <BaseSelector v-model="errorType"
                      :v="$v.errorType"
                      label="Error Type"
                      slug="errorType"
                      :options=errorOptions
        />
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-button type="button" variant="primary" @click="fetchRecords">Search</b-button>
        <b-button type="button" variant="secondary" class="mr-2" @click="clear">Clear</b-button>
      </b-col>
    </b-row>
    <b-row role="alert">
      <b-col>
        <div class="sr-only hidden" v-if="isLoading">Loading, Please Wait...</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table hover small responsive show-empty class="sr-caption"
                 aria-live="polite"
                 :fields="fields"
                 :items="records"
                 :busy="isLoading"
                 label-sort-asc=""
                 label-sort-desc=""
                 :current-page="currentPage"
                 :per-page="perPage"
                 caption="Registration Error Report table.  To sort the data in this table by a specific column,
                    go to the appropriate column header cell and use enter to sort the data ascending.
                    Use enter again to sort descending.">
          <template v-slot:empty="scope">
            <p>No results found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>

        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="fill"
                size="sm"
                class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset="8">
        <b-form-group
                label="Per page"
                label-size="sm"
                label-for="perPageSelect"
        >
          <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { excelService } from '@/mixins/excelService.js'

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  });

export default {
  data: () => ({
    fields: [
      {key: 'message', sortable: true, label: 'Error'},
      {key: 'errorDate', sortable: true, label: 'Date'},
      {key: 'errorType', sortable: true, label: 'Error Type'},
    ],
    isLoading: false,
    records: [],
    startDate: null,
    endDate: null,
    errorType: null,
    errorOptions: [{value: "CLAIM", text: ""}],
    perPage: 10,
    currentPage: 1,
    totalRows: 1,
    pageOptions: [5, 10, 15, 20],
  }),

  watch: {
    records() {
      this.isLoading = false
    },
  },

  created () {
    document.title = "Error Report - NAR"
  },

  methods: {
    clear() {
      this.startDate = null
      this.endDate = null
      this.records = []
      this.totalRows = 0
      this.currentPage = 1
    },
    fetchRecords() {
        this.isLoading = true;
        const payload = {
          startDate: this.startDate,
          endDate: this.endDate,
          errorType: this.errorType
        }
        let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/report/error`
        axios.post(fullUrl, payload)
          .then(response => {
              this.records = response.data;
              this.isLoading = false;
              this.totalRows = this.records.length
              this.currentPage = 1
          })
    },
  },

  validations: {
    startDate: { required: false },
    endDate: { required: false },
    errorType: { required: false }
  },
}
</script>